import React, { useCallback, useState } from 'react';
import Modal, { ModalBody, ModalTransition } from '@atlaskit/modal-dialog';
import { ShortcutScope } from '@atlassian/jira-common-components-keyboard-shortcuts';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import AsyncProjectCreateImporterUploadFlow from '@atlassian/jira-project-create-importer-upload-flow';
import type { Props } from './types';

const IMPORT_PROJECT_MODAL = 'projectImportModal';

const INITIAL_DIMENSIONS = {
	width: 'large',
	height: 'auto',
};

export const ImportModal = ({ isOpen, onClose, project }: Props) => {
	const [dimensions, setDimensions] = useState(INITIAL_DIMENSIONS);

	const expandModal = useCallback(() => {
		setDimensions({
			height: '100vh',
			width: '100vw',
		});
	}, []);

	const shrinkModal = useCallback(() => {
		setDimensions(INITIAL_DIMENSIONS);
	}, []);

	return (
		<ContextualAnalyticsData sourceName={IMPORT_PROJECT_MODAL} sourceType={MODAL}>
			<ModalTransition>
				{isOpen && (
					<ShortcutScope>
						<Modal
							width={dimensions.width}
							height={dimensions.height}
							shouldCloseOnOverlayClick={false}
							onClose={onClose}
							testId="project-create-import-modal.ui.template-modal"
						>
							<ModalBody>
								<AsyncProjectCreateImporterUploadFlow
									onEnterFullScreenMode={expandModal}
									onExitFullScreenMode={shrinkModal}
									project={project}
									projectType={null}
									onClose={onClose}
								/>
							</ModalBody>
						</Modal>
						<FireScreenAnalytics />
					</ShortcutScope>
				)}
			</ModalTransition>
		</ContextualAnalyticsData>
	);
};
